import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  props: [
    'data',
    'options',
    'chart'
  ],
  // mounted() {
  // TEMPORARILY COMMENTED OUT, MAY USE LATER?

  //   // create gradient fill under line
  //   let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
  //   gradient.addColorStop(0, this.chartGradientColor); // line color
  //   gradient.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
  //   this.data.datasets = [
  //     {
  //       ...this.data.datasets[0],
  //       backgroundColor: gradient
  //     }
  //   ]

  //   this.renderChart(this.data, this.options);
  // },
  computed: {
    chartGradientColor() {
      if (this.chart === 'membership') {
        return 'rgba(76, 105, 197, 0.25)'
      }
    }
  },
  watch: {
    async data() {
      let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);
      gradient.addColorStop(0, this.chartGradientColor); // line color
      gradient.addColorStop(.4, 'rgba(50, 65, 82, 0)'); // chart background color
      this.data.datasets = [
        {
          ...this.data.datasets[0],
          backgroundColor: gradient
        }
      ]

      this.renderChart(this.data, this.options);
    },
  },
};
